import Form from "components/Form";
import {
  SOS_STATUS,
  SOS_URL,
  TRANSLATION_DISCLAIMER_MESSAGE,
  URLS,
} from "configs/constants";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RecordTable from "./RecordTable";
import SOSTranslation from "./SOSTranslation";
import TranslationDetails from "./TranslationDetails";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import eightAxios from "configs/axiosConfig";
const initialValues = {
  status: "",
  attended_by: "",
  attended_date: null,
  attended_time: null,
  remarks: "",
};
const validationSchema = Yup.object({
  status: Yup.string()
    .required("Status is required")
    .typeError("Invalid Status"),
  attended_by: Yup.string()
    .required("Attended By is required")
    .typeError("Invalid Attended By"),
  attended_date: Yup.date().required("Date is required").nullable().typeError("Invalid Attended Date"),
 attended_time: Yup.string().required("Time is required").nullable().typeError("Invalid Attended TIme"),
});

function SOSForm() {
  const params = useParams();
  const { t } = useTranslation();

  const formButtons = ["save", "cancel"];


  const [currentSOSData, setCurrentSOSData] = useState({})
  const [timeFlag, setTimeFlag] = useState(true)
  useEffect(()=>{
    eightAxios
    .get(`sos/${params.id}/?from_frontend=true`)
    .then((response) => {
      setCurrentSOSData(response.data)      
    })
    .catch((err)=>{
      console.log(err);      
    })   
  },[])

  useEffect(()=>{
  const truncateToMinutes = (dateTime) => {
    return dateTime ? dateTime.slice(0, 16) : null
  }

  const createdAt = truncateToMinutes(currentSOSData?.created_at)
  const mobileDateTime = truncateToMinutes(currentSOSData?.mobile_date_time)
 
  if (createdAt === mobileDateTime) {
    setTimeFlag(true)
  } else {
    setTimeFlag(false)
  }
  },[currentSOSData])
  

  const formFields = [
    { type: "title", title: "Employee Details" },
    {
      type: "renderonly",
      label: "Employee ID",
      key: "worker_id",
    },
    {
      type: "renderonly",
      label: "Employee Name",
      key: "worker_name",
    },
    { type: "renderonly", label: "Mobile Number", key: "mobile_number" },
    {
      type: "renderonly",
      label: "Supervisor",
      key: "supervisor",
    },
    { type: "renderonly", label: "Nationality", key: "nationality" },
    { type: "renderonly", label: "Company", key: "company" },
    { type: "renderonly", label: "Zone", key: "zone" },
    { type: "renderonly", label: "Region", key: "region" },
    { type: "renderonly", label: "Estate", key: "estate" },
    { type: "renderonly", label: "Division", key: "division" },
    { type: "renderonly", label: "Block", key: "block" },

    { type: "title", title: "SOS Details" },
    { type: "renderonly", label: "SOS ID", key: "sos_id" },
    {
      type: "renderonly",
      label: "Server Date-Time",
      key: timeFlag ? "created_at" : "created_at_no",
      valueType: "date_time_origin",
    },
    {
      type: "renderonly",
      label: "Mobile Date-Time",
      key: !timeFlag ? "mobile_date_time" : "mobile_date_time_no",
      valueType: "date_time_origin",
    },
    {
      type: "renderonly",
      label: "Download Audio",
      key: "audio_download",
      valueType: "link",
      authClick: true,
      linkWrapper: "sos_id",
      linkWrapperText: "audio",
    },
    {
      type: "audio",
      key: "audio_play",
      label: "Play Audio",
    },
    {
      type: "renderonly",
      label: "Location",
      key: "location_link",
      valueType: "link",
      authClick: true,
      linkWrapper: "location_text",
      linkWrapperText: "location",
    },
    {
      type: "reactselect",
      name: "status",
      label: "Status",
      proxyUrl: SOS_STATUS,
      paginated: false,
      required: true,

      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
    },
    {
      type: "reactselect",
      name: "attended_by",
      label: "Attended By",
      proxyUrl: params.id ? `sos/${params.id}/attendees/` : null,
      paginated: false,
      required: true,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
    },
    {
      type: "datepicker",
      name: "attended_date",
      label: "Attended Date",
      required: true,
      size: "small",
      maxDate: new Date(),
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
    },
    {
      type: "timepicker",
      name: "attended_time",
      label: "Attended Time",
      size: "small",
      autoComplete: "off",
      helperText: "",
      emptyLabel: "",
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
      required: true,
    },
    {
      type: "input",
      size: "medium",
      name: "remarks",
      label: "Remarks",
      variant: "outlined",
      multiline: true,
      inputProps: { maxLength: 250 },
      rows: 3,
      gridSize: { xs: 12, sm: 12 },
    },
    { type: "title", title: "Translation Details" },
    {
      type: "component",
      component: SOSTranslation,
      passValueWithKey: "allowed_translation_count",
      gridSize: { xs: 12 },
    },
    {
      type: "title",
      title: "Previous Translation Details",
      showInfoIcon: true,
      infoContent: TRANSLATION_DISCLAIMER_MESSAGE,
    },
    {
      type: "component",
      component: TranslationDetails,
      passValueWithKey: "translations",
      gridSize: { xs: 12 },
    },
    { type: "title", title: "Access History" },
    {
      type: "component",
      component: RecordTable,
      key: "audio_downloaded_by",
      title: "Who Downloaded The Audio?",
      gridSize: { xs: 12 },
      columns: [
        { field: "id", name: "No." },
        { field: "datetime", name: t("Date and Time") },
        { field: "name", name: t("Name") },
      ],
    },
    {
      type: "component",
      component: RecordTable,
      key: "audio_played_by",
      title: "Who Played The Audio?",
      gridSize: { xs: 12 },
      columns: [
        { field: "id", name: "No." },
        { field: "datetime", name: t("Date and Time") },
        { field: "name", name: t("Name") },
      ],
    },
    {
      type: "component",
      component: RecordTable,
      key: "link_clicked_by",
      title: "Who Clicked The Link Location?",
      gridSize: { xs: 12 },
      columns: [
        { field: "id", name: "No." },
        { field: "datetime", name: t("Date and Time") },
        { field: "name", name: t("Name") },
      ],
    },
  ];

  return (
    <Form
    validationSchema={validationSchema}
      initialValues={initialValues}
      submitUrl={SOS_URL}
      formFields={formFields}
      listRoute={URLS.SOS_LIST}
      formButtons={formButtons}
      formTitle="SOS"
      noListButton
      isMultipart
    />
  );
}

export default SOSForm;
